import { useEffect } from "react"

interface UseActiveItemAutoScrollOptions {
  activeItemId: string | null
  selectorAttribute: string
}

export function useActiveItemAutoScroll({
  activeItemId,
  selectorAttribute,
}: UseActiveItemAutoScrollOptions) {
  useEffect(() => {
    if (!activeItemId || typeof document === "undefined") {
      return
    }

    const escapedId =
      typeof CSS !== "undefined" && typeof CSS.escape === "function"
        ? CSS.escape(activeItemId)
        : activeItemId.replace(/"/g, '\\"')

    const element = document.querySelector<HTMLElement>(
      `[${selectorAttribute}="${escapedId}"]`,
    )

    element?.scrollIntoView({
      block: "nearest",
    })
  }, [activeItemId, selectorAttribute])
}
